import { chimeIconColorSelectorMap, styled } from 'helpers';

import Icon from './Icon';
import { Icons } from './icons';

const StyledIcon = styled(Icon)(({ icon }) => {
  let styles = {};

  if (icon === Icons.chime) {
    const chimeStyles = Object.entries(chimeIconColorSelectorMap).reduce((styles, [color, selector]) => {
      styles[selector] = {
        fill: color,
      };
      return styles;
    }, {} as { [key: string]: { fill: string } });

    styles = {
      ...styles,
      ...chimeStyles,
    };
  }

  return styles;
});

export default StyledIcon;
